module.exports = __webpack_public_path__ + "img/join_1.58f21edb.svg";